import Button from "components/common/Button";
import { DownloadOutlined } from "@ant-design/icons";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";
import { Col, Dropdown, Menu, Row } from "antd";
import useWindowSize from "useWindowSize";
import Selector from "components/common/Selector";
import s from "../../../styles/TopMenu.styles";
import CustomDatePicker from "components/common/CustomDatePicker";

function TopMenu({
  value,
  onChange,
  selectedWorker,
  changeSelectedWorker,
  selectStore,
  setSelectStore,
  workersOptions,
  storesOptions,
  exportFileExcel,
  getImageGraph,
  disabled,
  loading,
}) {
  const { t } = useTranslation();

  const { width } = useWindowSize();

  const menu = (
    <Menu style={{ padding: "8px" }}>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000", border: "none" }}
          disabled={disabled}
          onClick={() => exportFileExcel()}
        >
          Excel
        </Button>
      </Menu.Item>
      <Menu.Item>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          size="large"
          style={{ color: "#000", border: "none" }}
          disabled={disabled}
          onClick={() => getImageGraph()}
        >
          Pdf
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <s.Container
      style={{
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Row
        style={{
          width: "100%",
        }}
      >
        <Col
          xs={24}
          md={24}
          lg={14}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Row gutter={[10, 10]}>
            <CustomDatePicker
              loading={loading}
              value={value}
              onChange={onChange}
            />
          </Row>
        </Col>

        <Col
          xs={24}
          md={24}
          lg={10}
          gutter={[10, 10]}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: "10px",
            ...(width <= 990 && {
              justifyContent: "flex-start",
            }),
          }}
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {width > 768 && (
              <s.Title>{t("containers.ClockSessions.TopMenu.selectStore")}</s.Title>
            )}
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <Selector
                disabled={loading}
                options={storesOptions}
                placeholder={t("containers.ClockSessions.TopMenu.selectStore")}
                style={{ width: 147, marginBottom: "7px" }}
                onChange={(value) => setSelectStore(value)}
                value={selectStore}
                bordercolor={Colors.background_dividers}
              />
            </div>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {width > 768 && (
              <s.Title>{t("containers.ClockSessions.TopMenu.selectWorker")}</s.Title>
            )}
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <Selector
                disabled={loading || workersOptions.length === 0}
                options={workersOptions}
                placeholder={t("containers.ClockSessions.TopMenu.selectWorker")}
                style={{ width: 147, marginBottom: "7px" }}
                onChange={(value) => changeSelectedWorker(value)}
                value={selectedWorker}
                bordercolor={Colors.background_dividers}
              />
              <s.downloadButtonContainer>
                <Dropdown disabled={loading} overlay={menu}>
                  <Button
                    style={{
                      height: "40px",
                      width: "40px",
                      borderColor: Colors.icon_secondary,
                    }}
                    icon={<DownloadOutlined />}
                  />
                </Dropdown>
              </s.downloadButtonContainer>
            </div>
          </Col>
        </Col>
      </Row>
    </s.Container>
  );
}

export default TopMenu;
